import {
  useAdminStore,
  useCopilotStore,
  useKnowledgeStore,
} from '@getmayday/vue-modules';
import { useAgentStore } from '@getmayday/vue-modules/agent';

const useCopilot = () => {
  const adminStore = useAdminStore();
  const copilotStore = useCopilotStore();
  const knowledgeStore = useKnowledgeStore();
  const configStore = useConfigStore();
  const agentStore = useAgentStore();
  const { loggedIn, hasCompanyBrainAutomationsPreference } =
    storeToRefs(adminStore);
  const { focusedTicket, ticketContext, copilotRecommendations } =
    storeToRefs(copilotStore);
  const { focusKnowledge } = storeToRefs(knowledgeStore);
  const { currentTabContext } = storeToRefs(configStore);
  const {
    currentAgent,
    appContext,
    getAgentsWithTool,
    currentAgentCopilotTool,
  } = storeToRefs(agentStore);

  const displayCopilot = computed(
    () =>
      loggedIn.value &&
      hasCompanyBrainAutomationsPreference.value &&
      (!!focusedTicket.value ||
        (ticketContext.value &&
          ticketContext.value.sentiment &&
          ticketContext.value.user_request)),
  );
  const displayRestrictedCopilot = computed(
    () =>
      loggedIn.value &&
      !hasCompanyBrainAutomationsPreference.value &&
      copilotRecommendations.value &&
      copilotRecommendations.value.length > 0,
  );

  const defaultAgentId = computed(() => {
    if (!!currentTabContext.value?.conversationId && !focusedTicket.value)
      return 'mayday:ask';
    if (currentAgentCopilotTool.value) return currentAgent.value?.id;
    const agentsWithCopilotTool = getAgentsWithTool.value('copilot');
    return agentsWithCopilotTool.length ? agentsWithCopilotTool[0].id : null;
  });

  const initGenius = () => {
    if (appContext.value && focusKnowledge.value) {
      agentStore.setAppContext({
        ...appContext.value,
        knowledgeId: focusKnowledge.value.id,
      });
    }

    if (!currentAgent.value?.id)
      agentStore.setCurrentAgent(defaultAgentId.value);
  };

  return {
    displayCopilot,
    displayRestrictedCopilot,
    initGenius,
    defaultAgentId,
  };
};

export default useCopilot;
